var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClockBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66699C14.6026 1.66699 18.3334 5.39866 18.3334 10.0003C18.3334 14.602 14.6026 18.3337 10.0001 18.3337C5.39758 18.3337 1.66675 14.602 1.66675 10.0003C1.66675 5.39866 5.39758 1.66699 10.0001 1.66699ZM10.0001 3.05616C6.17092 3.05616 3.05591 6.17116 3.05591 10.0003C3.05591 13.8295 6.17092 16.9445 10.0001 16.9445C13.8292 16.9445 16.9442 13.8295 16.9442 10.0003C16.9442 6.17116 13.8292 3.05616 10.0001 3.05616ZM9.37508 5.00033C9.69133 5.00033 9.95296 5.2356 9.99437 5.54055L10.0001 5.62533V10.0003H12.7084C13.0534 10.0003 13.3334 10.2803 13.3334 10.6253C13.3334 10.9416 13.0981 11.2032 12.7932 11.2446L12.7084 11.2503H9.37508C9.05883 11.2503 8.7972 11.015 8.75579 10.7101L8.75008 10.6253V5.62533C8.75008 5.28033 9.03008 5.00033 9.37508 5.00033Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockBlack);
export default __webpack_public_path__ + "static/media/icon-clock-black.03c11a7d8ab37ec58f5feaeab41a5226.svg";
export { ForwardRef as ReactComponent };